














import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import {
  Action,
  Getter,
  Mutation,
} from 'vuex-class';
import { ApiV2Service } from '@/services/api.base.service';
import Transformation from '@/classes/transformation';
import Drawer from '@/components/Drawer.vue';

@Component({
  components: {
    Drawer,
  },
})
export default class Publish extends Vue {

  @Getter private activeOrganisation: any;
  @Getter private activeOrganisationId!: number;
  @Getter private hasPermission: any;

  private activeIndex: number = 0;
  private activeList: object[] = [];
  private hasNRInstance: boolean = false;

  public async mounted() {
    this.activeIndex = this.activeList.findIndex((item: any) => this.$route.name!.includes(item.name));
     /* if (this.activeIndex < 2) {
      await this.checkForNRInstance();
      if (!this.hasNRInstance) {
        // this.$router.replace({name: 'dataSets', params: {organisationId: this.activeOrganisationId.toString()}});
      }
    }*/
  }

  private isDisabled(index: number) {
    return index < 2 && !this.hasNRInstance;
  }

  private toggleActiveIndex(list: object[], index: number) {
    this.activeIndex = index;
    this.activeList = list;
  }

  private get getSelection() {
    if (this.activeList.length <= 1) {
      return 0;
    } else {
      this.activeIndex = this.activeList.findIndex((item: any) => this.$route.name!.includes(item.name));
      return this.activeIndex;
    }
  }

  private async checkForNRInstance(): Promise<void> {
    // const orgSlug = this.activeOrganisation[0].slug.replace('_', '');
    const hashSlug = Transformation.hashOrgSlug(this.activeOrganisation[0].slug);
    try {
      const result = await ApiV2Service.headExt(`https://${hashSlug}.daizy.io`);
      this.hasNRInstance = true;
    } catch (e: any) {
      this.hasNRInstance = false;
    }
  }
}
